<p-dialog
  header="Modifier les travaux correctifs"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '90vw', 'max-width': '800px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onCancel()"
>
  <div class="edit-corrective-actions-modal">
    <div class="modal-content">
      <form [formGroup]="form">
        <div formArrayName="correctiveActions" class="actions-list">
          <div
            *ngFor="
              let actionGroup of formArray.controls;
              let i = index
            "
            [formGroupName]="i"
            class="action-row"
            [ngClass]="{ deleted: !isVisibleRow(i) }"
            [style.display]="isVisibleRow(i) ? 'flex' : 'none'"
          >
            <div class="action-description">
              <input
                type="text"
                pInputText
                formControlName="description"
                placeholder="Description du travail correctif"
                [class.ng-invalid]="
                  actionGroup.get('description')?.invalid &&
                  actionGroup.get('description')?.touched
                "
              />
              <small
                *ngIf="
                  actionGroup.get('description')?.invalid &&
                  actionGroup.get('description')?.touched
                "
                class="error-message"
              >
                La description est requise
              </small>
            </div>

            <div class="action-actions">
              <button
                type="button"
                pButton
                pRipple
                icon="pi pi-trash"
                class="p-button-danger p-button-sm p-button-outlined"
                (click)="deleteAt(i)"
                [disabled]="formArray.length <= 1"
              ></button>
            </div>
          </div>

          <div class="add-action-section">
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-plus"
              label="Ajouter un travail correctif"
              class="p-button-secondary p-button-outlined"
              (click)="addNew()"
            ></button>
          </div>
        </div>
      </form>

      <div *ngIf="!isFormValid" class="validation-warning">
        <div class="warning-content">
          <i class="pi pi-exclamation-triangle"></i>
          <span>{{ validationMessage }}</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button
        type="button"
        pButton
        pRipple
        label="Annuler"
        class="p-button-text"
        (click)="onCancel()"
      ></button>
      <button
        type="button"
        pButton
        pRipple
        label="Enregistrer"
        class="p-button-primary"
        (click)="onSubmit()"
        [disabled]="!isFormValid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
